import constants from '@/constants'

export default {
  computed: {
    $constants: () => constants,
  },
}
